<template>
    <div>
        <Header :logoUrl="logoUrl" />
        <router-view />
        <Footer :urlVideo="urlVideo" :brochureUrl="brochureUrl" />
    </div>
</template>

<script>
import Header from "../core/Header";
import Footer from "../core/Footer.vue";
export default {
    name: "ValleNorte",
    data() {
        return {
            logoUrl: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/vallenorte/terrenoLogo/vallenortelogo.svg",
            brochureUrl: 'https://tresmarias.s3.us-west-2.amazonaws.com/assets/brochure/ValleNorte.pdf',
            urlVideo: 'https://tresmarias.s3.us-west-2.amazonaws.com/videos/58.mp4'
        };
    },
    components: {
        Header,
        Footer,
    },
};
</script>

<style>
:root {
    --animate-duration: 250ms;
    --animate-delay: 0.9s;
}

.quick {
    transition-duration: "0ms" !important;
}
</style>
